@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.text {
  @include md-sohne;
  color: var(--dark-80);
  display: flex;
  align-items: center;
  gap: 4px;

  span {
    margin-bottom: 1px;
    margin-top: -1px;
  }

  @include for-desktop-only {
    display: inline-flex;
    align-items: center;
  }
}

.icon {
  margin: 0 0 -1px 0;
  width: 12px;
  height: 12px;

  @include for-phone-only {
    width: 14px;
    height: 14px;
  }
}
